<template>
  <div id="AdminQueryGroupNewsletter">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ newsletter }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Gruppi Automatici</router-link>
      </li>
    </ol>
      <div class="container-fluid card-title-admin">
        <h1>Gruppi Automatici</h1>
    </div>
     <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-12 text-left">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onClickNew"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
                 <button
                            id="btnconfirmSaveRow"
                            type="button"
                            class="btn btn-success"
                            @click="confirmSaveRow"
                            :disabled="disableButton"
                          >
                            <i class="fa fa-floppy-o"></i>
                            <span>Salva</span>
                          </button>
                          <button
                            id="btnconfirmDeleteRow"
                            type="button"
                            class="btn btn-danger"
                            @click="confirmDeleteRow"
                            :disabled="disableButton"
                          >
                            <i class="fa fa-trash"></i>
                            <span>Elimina</span>
                          </button>
              </div>
            </div>
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableGroups"
                ref="tableGroups"
                :onCheck="onTableListCheck"
                :onCheckAll="onTableListCheck"
                :onUncheck="onTableListCheck"
                :onUncheckAll="onTableListCheck"
                :results="tableQueryGroupNewsletterResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabQueryGroupNewsletterDetail" role="tabpanel" style="box-shadow:none;padding:30px;">
            <div class="card-body" style="padding:30px;">
              <div class="row">
                <div v-if="rowIdSelected > 0">
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Modifica</h1>
                      </div>
                      <div v-else>
                      <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Aggiungi</h1>
                      </div>
                <pageDetail
                  functions="AdminSettingNation"
                  :configurations="detailQueryGroupNewslConfiguration"
                  :jsonValue="detailQueryGroupNewsletterData"
                ></pageDetail>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewQueryGroupNewsletter"
                  > <i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
                  <button
                    type="button"
                    class="btn btn-success"
                    @click="saveNewQueryGroupNewsletter"
                  > <i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
                    <button
                    type="button"
                    class="btn btn-light"
                    @click="executeRunQuery"
                  > <i class="fa fa-arrow-right"></i>&nbsp;Esegui</button>
                </div>
              </div>
            </div>
          </div>

        <!-- popup query execute; --> 
        <div
                    class="modal"
                    id="tabExecuteQueryResult"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-lg" role="document" style="max-width: 90%!important;">
                      <div class="modal-content padding" style="min-height: 94vh;">
                        <div class="modal-header text-center" style="border-bottom: #fff;">
                          <h4 class="modal-title w-100 font-weight-bold">
                           Risultato esecuzione query
                          </h4>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body mx-12">
                          <div class="md-form mb-12">
                            <div class="row" style="max-height: 84vh;overflow: auto;">
                              <div class="col-12" style="overflow:auto;height: 84vh;">
                              <table class="table table-striped">
                                 <tr class="row-preview-query"
                                  v-for="(key, value) in ResultQuery" 
                                  v-bind:key="key"
                                >
                                 <td class="col-preview-query"
                                  v-for="(key1, value1) in key" 
                                  v-bind:key="key1"
                                >
                                  <div>
                                      <strong>{{value1}}</strong><br>
                                      <label>{{key1}}</label>
                                  </div>
                                  </td>
                                </tr>
                              </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
        <!--end popup query execute; --> 
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "AdminQueryGroupNewsletter",
  components: {
    BootstrapTable,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      newsletter: dictionaryHelpers.getDictionary("Newsletter"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      disableButton: true,
      ResultQuery:[],
      detailQueryGroupNewslConfiguration: [],
      tableQueryGroupNewsletterResult: [],
      detailQueryGroupNewsletterData: {},
      tableConfiguration: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      url: window.location.pathname
    };
  },
  created() {
    var AdminQueryGroupNewsletter = this;
    spinnerHelpers.show();
    AdminQueryGroupNewsletter.defaultLanguageOptions = {
    id: storageData.sIdLanguage(),
    text: storageData.sDescriptionLanguage()
    };

    spinnerHelpers.show();
      adminConfigurationServices.getFunctionality(function(result) {    
      AdminQueryGroupNewsletter.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      AdminQueryGroupNewsletter.detailQueryGroupNewslConfiguration = result.data.tabsConfigurations[0].pageConfigurations;
      AdminQueryGroupNewsletter.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var AdminQueryGroupNewsletter = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }
      
      QueryGroupNewsletterServices.getAll(function(result) { 
        AdminQueryGroupNewsletter.tableData = result.data;
        spinnerHelpers.hide();
      });
    },

    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableGroups.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var AdminQueryGroupNewsletter = this;
      AdminQueryGroupNewsletter.loadTable(value);
      spinnerHelpers.hide();

    },


    confirmSaveRow(){
      if (confirm("Confermi il salvataggio?")) {
        this.executeSaveRow();
      }
    },

    executeSaveRow() {
      spinnerHelpers.show();
      var AdminQueryGroupNewsletter = this;
      this.rowsSelected = 0;
      this.tableResult = [];
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(
        this.$refs.tableGroups.getRowSelected(),
        function(i, row) {
          var rowToSave = row;
          rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
          AdminQueryGroupNewsletter.rowsSelected = AdminQueryGroupNewsletter.rowsSelected + 1;

          QueryGroupNewsletterServices.update(
            rowToSave,
            function() {
              AdminQueryGroupNewsletter.checkAllIsSaved();
              AdminQueryGroupNewsletter.tableResult.push({
                id: rowToSave.id,
                success: true
              });
              notificationHelpers.success("Aggiornamento avvenuto con successo!");
            },
            function(response) {
              AdminQueryGroupNewsletter.checkAllIsSaved();
              AdminQueryGroupNewsletter.tableResult.push({
                id: rowToSave.id,
                success: false,
                message: response
              });
              notificationHelpers.error(response);
            }
          );
        }
      );
    },

    confirmDeleteRow(){  
      if (confirm("Sei sicuro di voler eliminare?")) {
        this.executeDeleteRow();
      }
    },
     executeDeleteRow() {
      spinnerHelpers.show();
      var AdminQueryGroupNewsletter = this;
      this.rowsSelected = 0;
      this.tableResult = [];
      $.each(
        this.$refs.tableGroups.getRowSelected(),
        function(i, row) {
          AdminQueryGroupNewsletter.rowsSelected = AdminQueryGroupNewsletter.rowsSelected + 1;
          QueryGroupNewsletterServices.del(row.id,
            function() {
              AdminQueryGroupNewsletter.checkAllIsSaved();
              notificationHelpers.success("Cancellazione Avvenuta con Successo");
            },
            function(response) {
              AdminQueryGroupNewsletter.checkAllIsSaved();
              AdminQueryGroupNewsletter.tableResult.push({
                id: rowToSave.id,
                success: false,
                message: response
              });
                notificationHelpers.error(response);
            }
          );
        }
      );
    },

    onTableListCheck: function() {
      var countRowSelected = this.$refs.tableGroups.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
        this.disableTab = true;
      } else {
        if (countRowSelected == 1) {
          this.disableTab = false;
        } else {
          this.disableTab = true;
        }
        this.disableButton = false;
      }
    },

  checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable();
      }
    },


    QueryGroupNewsletterFormatter(value, row, index, field) {
      var AdminQueryGroupNewsletter = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="AdminQueryGroupNewsletter.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
      html +=
        '<button class="btn btn-danger" onclick="AdminQueryGroupNewsletter.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      return html;
    },

    viewDatailInfo(id){
      spinnerHelpers.show();
      var AdminQueryGroupNewsletter = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function(i, row) {
        if (AdminQueryGroupNewsletter.rowIdSelected == row.id) {
          AdminQueryGroupNewsletter.detailQueryGroupNewsletterData = row;
        }
      });
      $("#tabTable").removeClass("active");
      $("#tabQueryGroupNewsletterDetail").addClass("active");
      spinnerHelpers.hide();

    },


    delete(id) {
      var AdminQueryGroupNewsletter = this;
      if (confirm("Sei sicuro di voler eliminare?")) {
        AdminQueryGroupNewsletter.executeCancelData(id);
      }
    },

    executeCancelData(id) {
      var AdminQueryGroupNewsletter = this;
      spinnerHelpers.show();
      QueryGroupNewsletterServices.del(id, function() {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        var ln = AdminQueryGroupNewsletter.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        AdminQueryGroupNewsletter.loadTable(ln);
        window.scrollTo(0, 0);
        });
    
    },

    onClickNew() {
      spinnerHelpers.show();
      this.rowIdSelected = 0;
      this.detailQueryGroupNewsletterData = {};
      $("#tabTable").removeClass("active");
      $("#tabQueryGroupNewsletterDetail").addClass("active");
      spinnerHelpers.hide();
    },

    cancelNewQueryGroupNewsletter(){
      spinnerHelpers.show();
      this.detailQueryGroupNewsletterData = {};
      $("#tabTable").addClass("active");
      $("#tabQueryGroupNewsletterDetail").removeClass("active");
      spinnerHelpers.hide();
    },
    
     executeRunQuery() {  
     var AdminQueryGroupNewsletter = this;    
        $("#tabExecuteQueryResult").modal("show");
        console.log(this.detailQueryGroupNewsletterData);
        QueryGroupNewsletterServices.executequeryresult(this.detailQueryGroupNewsletterData, function (result) {
        console.log(result.data);  
        AdminQueryGroupNewsletter.ResultQuery = result.data;

      });   

     /*   groupNewsletterServices.getAllByUser(data, function(result) { 
        console.log(result.data); 
        adminNewsletterCampaign.tableDataUsers = result.data;
        spinnerHelpers.hide();
      });*/
    },

    saveNewQueryGroupNewsletter(){
      spinnerHelpers.show();
      var AdminQueryGroupNewsletter = this;
      this.detailQueryGroupNewsletterData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        this.detailQueryGroupNewsletterData.id = this.rowIdSelected;

        QueryGroupNewsletterServices.update(this.detailQueryGroupNewsletterData, function (result) {
          notificationHelpers.success(AdminQueryGroupNewsletter.updateCompleted);
          AdminQueryGroupNewsletter.loadTable();
          $('#tabTable').addClass('active');
          $('#tabQueryGroupNewsletterDetail').removeClass('active');
        })
      } else {
        QueryGroupNewsletterServices.insert(this.detailQueryGroupNewsletterData, function (result) {
          notificationHelpers.success(AdminQueryGroupNewsletter.insertCompleted);
          AdminQueryGroupNewsletter.loadTable();
          $('#tabTable').addClass('active');
          $('#tabQueryGroupNewsletterDetail').removeClass('active');
        })
      }
    }
  }
};
</script>

<style>
.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}

.col-preview-query{}

.row-preview-query{}
</style>
